import { useEffect } from "react";
import { useNavigate } from "react-router";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";

export const LogoutCallback = () => {
    var navigate = useNavigate();

    useEffect(() => {
        navigate("/", { replace: true });
    }, [])

    return <AbpnSpinner></AbpnSpinner>
}